const lenientSources = new WeakSet<object>();

export function markLenientSource<T>(source: T): T {
    if (source !== null && typeof source === 'object') lenientSources.add(source);
    return source;
}

export function isLenientSource(source: unknown): boolean {
    return source !== null && typeof source === 'object' && lenientSources.has(source);
}
